<template>
  <div class="pageWrapper">
    <div class="pageContent">
      <div
          @click="toggleExpand"
          class="eachBoxStyle firstSection mt-5"
          :class="{ expanded: isExpanded }"
          style="cursor: pointer"
      >
        <div class="firstSectionTop title-medium-20">{{ $t("newPreSession.sessionInfo") }}</div>

        <div class="divider"></div>

        <div class="firstSectionBottom body-large-18-medium">
          <img
              src="@/assets/newPreSession/greenSleeve.gif"
              alt=""
              class="sleeveImage"
          />
          {{ $t('newPreSession.sessionHelpText') }}
          <div class="downArrowSection">
            <img
                src="@/assets/newPreSession/arrowDown.png"
                alt=""
                class="downArrowSelf"
                :class="{ rotated: isExpanded }"
            />
          </div>
        </div>

        <transition name="expandHeight">
          <div v-show="isExpanded" class="expandedContent">
            <div v-if="isExpanded">
              <div class="infoRow body-medium-16-medium">
                <span class="infoLabel body-medium-16-medium">{{ $t("newPreSession.sessionDuration") }}</span>
                <span class="infoValue body-medium-16-medium">&nbsp;15 {{ $t("newPreSession.min") }}</span>
              </div>
              <div class="infoRow body-medium-16-medium">
                <span class="infoLabel body-medium-16-medium"
                >
                  {{ $t("newPreSession.sessionOrganizer") }}
                </span
                >
                <span class="infoValue body-medium-16-medium"
                >
                    &nbsp;{{ $t("newPreSession.sessionOrganizerText") }}
                 </span
                 >
              </div>
              <div class="infoRow body-medium-16-medium">
                <span class="infoLabel body-medium-16-medium"
                >
                   {{ $t("newPreSession.sessionLocation") }}
                 </span
                 >
                <span class="infoValue body-medium-16-medium"
                >
                  &nbsp;{{ $t("newPreSession.sessionLocationText") }}
                </span
                >
              </div>
            </div>
          </div>
        </transition>
      </div>
      <div v-if="!emptyState" class="eachBoxStyle secondSection mt-4">
        <div class="firstSectionTop title-medium-20">
          {{ $t("newPreSession.selectTime") }}
        </div>
        <div class="divider"></div>

        <div class="timezoneInputWrapper">
          <v-autocomplete
              ref="timezoneSelect"
              class="timezoneInput"
              :items="timezones"
              :label="$t('newPreSession.selectTimezone')"
              v-model="selectedTimeZone"
              item-text="text"
              @change="onTimeZoneChange"
              item-value="value"
              outlined
              :menu-props="{
              closeOnClick: true,
              contentClass: 'timezoneDropdownMenu',
            }"
          >
            <template v-slot:item="{ item }">
              <div class="timezone-item">
                <div class="d-flex flex-row">
                  <div class="d-flex align-center">
                    <img
                        src="@/assets/newPreSession/world.png"
                        alt=""
                        class="globeImg"
                    />
                  </div>
                  <div>
                    <div>{{ item.text }}</div>
                    <div>{{ item.country }}</div>
                  </div>
                </div>
              </div>
            </template>

            <template v-slot:append>
              <img
                  src="@/assets/newPreSession/arrowDown.png"
                  alt=""
                  class="downArrowSelf"
                  :class="{ rotated: $refs.timezoneSelect?.isMenuActive }"
              />
            </template>
          </v-autocomplete>
          <div class="divider"></div>
        </div>
        <div :class="{ 'is-locked': isFormLocked }">
          <div class="body-large-18-medium noteBookRow">
            <img
                alt=""
                :class="$vuetify.rtl ? 'noteBook' : 'noteBookLtr'"
                src="@/assets/newPreSession/notebook.gif"
            />

            <div class="body-large-18-medium" style="color: #212121">
              {{ $t("newPreSession.preferredTime") }}

            </div>
          </div>

          <v-radio-group
              class="my-radio-group"
              :value="selectedTimeOption"
              style="margin: 0 !important"
          >
            <div
                @click="
                () => {
                  selectedTimeOption = 'closest';
                }
              "
                :style="{
                'border-color':
                  selectedTimeOption === 'closest' ? '#39C990' : '#EAF0F6',
                cursor: 'pointer',
              }"
                :class="[
                'eachBoxStyle',
                'timingMargins',

                { selectedBorder: selectedTimeOption === 'closest' },
              ]"
            >
              <div
                  class="body-large-18-medium"
                  :class="$vuetify.rtl ? 'text-right' : 'text-left'"
                  style="color: #424242"
              >
                {{ $t("newPreSession.closestTime") }}

              </div>

              <div class="d-flex flex-row mt-2">
                <div class="body-large-18-medium" style="color: #616161"></div>

                <v-radio
                    value="closest"
                    style="display: inline !important; margin: 0 !important"
                >
                </v-radio>
                <div style="color: #616161" class="body-large-18-medium">
                  <!--                15:00 عصر یکشنبه 2025/02/24 - ساعت-->
                  {{ closestTime }}
                </div>
                <div class="d-flex flex-grow-1 justifyd align-center">
                  <div
                      v-if="timesRefreshed"
                      class="recentlyUpdatedDiv"
                      :class="{ animateCaution: animateBorder }"
                  >
                    <img
                        src="@/assets/newPreSession/caution.png"
                        alt=""
                        class="cautionImage"
                    />

                    <div class="title-small-16" style="color: #fead20">
                      {{ $t("newPreSession.timesUpdated") }}

                    </div>
                  </div>
                  <div></div>
                </div>
              </div>

            </div>
            <div
                @click="
                () => {
                  selectedTimeOption = 'fixed';
                }
              "
                :style="{
                'border-color':
                  selectedTimeOption !== 'closest' ? '#39C990' : '#EAF0F6',
                cursor: 'pointer',
              }"
                class="eachBoxStyle timingMargins mt-3"
            >
              <div class="body-large-18-medium" style="color: #424242"></div>

              <div class="d-flex flex-row mt-2">
                <div class="body-large-18-medium" style="color: #616161"></div>

                <v-radio value="fixed" style="display: inline !important">
                </v-radio>

                <div class="body-large-18-medium" style="color: #616161">
                  {{ $t("newPreSession.calendarAndOtherTimes") }}

                </div>
              </div>
            </div>
          </v-radio-group>

          <div class="timeSection" v-if="selectedTimeOption === 'fixed'">
            <div
                @click="onSelectingDate(eachDay.date)"
                v-for="eachDay in availableTimes.slice(0,7)"
                :key="eachDay.date"
                :class="{
                selectedDay: selectedDate === eachDay.date,
                disabledDay: eachDay.disabled,
              }"
                class="eachTimeBox"
            >
              <div style="color: #616161" class="body-large-18-medium">
                {{ getDayName(eachDay.date) }}
              </div>
              <div style="color: #616161" class="">
                {{ formatEachDate(eachDay.date) }}
              </div>
              <div
                  class="body-large-14-medium mt-3"
                  :style="{
                  color: eachDay.periods.length >= 3 ? '#00C853' : '#ff5252',
                }"
              >
                <span
                    class="body-small-14-medium"
                    v-if="eachDay.periods.length"
                >
                  {{ eachDay.periods.length }}
                  {{ $t("newPreSession.times") }}


                </span>
                <span v-else>-</span>
              </div>
            </div>
          </div>

          <div v-if="selectedDate">
            <v-tabs
                v-model="selectedTab"
                fixed-tabs
                color="#39C990"
                background-color="transparent"
                show-arrows
            >
              <v-tab style="font-size: 16px" class="body-large-18-medium"
              >
                {{ $t("newPreSession.morning") }}

              </v-tab
              >
              <v-tab style="font-size: 16px" class="body-medium-16-medium"
              >
                {{ $t("newPreSession.afternoon") }}

              </v-tab
              >
              <v-tab style="font-size: 16px" class="body-medium-16-medium"
              >
                {{ $t("newPreSession.evening") }}

              </v-tab
              >
            </v-tabs>

            <v-tabs-items v-model="selectedTab">
              <v-tab-item>
                <div v-if="morningTimes.length" class="time-row">
                  <div
                      @click="selectedDayTime = eachTime.id"
                      v-for="eachTime in morningTimes"
                      :key="eachTime.id"
                      class="time-box eachDayTime body-small-14-medium"
                      :class="{ selectedDay: selectedDayTime === eachTime.id }"
                  >
                    {{ eachTime.time }}
                  </div>
                </div>
                <div
                    style="color: #616161"
                    v-else
                    class="body-large-18-medium timeSection text-center"
                >
                  {{ $t("newPreSession.noEmptySlots") }}

                </div>
              </v-tab-item>
              <v-tab-item>
                <div v-if="afternoonTimes.length" class="time-row">
                  <div
                      @click="selectedDayTime = eachTime.id"
                      v-for="eachTime in afternoonTimes"
                      :key="eachTime.id"
                      class="time-box eachDayTime body-small-14-medium"
                      :class="{ selectedDay: selectedDayTime === eachTime.id }"
                  >
                    {{ eachTime.time.replace("Afternoon", "AM") }}
                  </div>
                </div>
                <div
                    style="color: #616161"
                    v-else
                    class="body-large-18-medium timeSection text-center"
                >
                  {{ $t("newPreSession.noEmptySlots") }}

                </div>
              </v-tab-item>
              <v-tab-item>
                <div v-if="nightTimes.length" class="time-row">
                  <div
                      @click="selectedDayTime = eachTime.id"
                      v-for="eachTime in nightTimes"
                      :key="eachTime.id"
                      class="time-box eachDayTime body-small-14-medium"
                      :class="{ selectedDay: selectedDayTime === eachTime.id }"
                  >
                    {{ eachTime.time.replace("Evening", "PM") }}
                  </div>
                </div>
                <div
                    style="color: #616161"
                    v-else
                    class="body-large-18-medium timeSection text-center"
                >
                  {{ $t("newPreSession.noEmptySlots") }}

                </div>
              </v-tab-item>
            </v-tabs-items>
          </div>

          <div class="inspirationDiv">
            <img
                src="@/assets/newPreSession/smallSleeve.png"
                alt=""
                class="smallSleeve"
            />
            <div class="title-small-14" style="color: #035184">

              {{ $t("newPreSession.withChat") }}

            </div>
          </div>

          <v-row class="submitSectionMargins align-center justify-center">
            <v-col cols="6">
              <div v-if="finalDate">
                <span class="body-large-18-medium">{{
                    finalDate.split(",")[0] ?? ""
                  }}</span>
                <span class="" style="color: #035184">{{
                    finalDate.split(",")[1] ?? ""
                  }}</span>
              </div>
              <div v-else>
                <span style="color: #424242" class="body-large-18-medium"
                >
            {{ $t("newPreSession.chooseDateTime") }}

                 </span
                 >
              </div>
            </v-col>
            <v-col cols="6" class="d-flex align-end justify-end">
              <div
                  id="new-pre-session-step-two-free-time"
                  @click="submitForm"
                  class="title-small-16"
                  :class="[
                  'submitBtn',
                  { 'is-disabled': loading || isFormLocked },
                ]"
              >
                {{ $t("newPreSession.confirmAndContinue") }}
              </div>
            </v-col>
          </v-row>
        </div>
      </div>
      <div
          id="presessionHasNoAvailableTimes"
          v-else
          class="eachBoxStyle secondSection mt-4 text-center emptyPanel"
      >
        <img
            src="@/assets/newPreSession/emptyState.png"
            alt=""
            class="emptyImage"
        />
        <div style="color: #212121" class="body-large-18-medium mt-5">
          {{ $t("newPreSession.noAvailableTimes") }}

        </div>
        <div style="color: #212121" class="body-large-18-medium">
          {{ $t("newPreSession.notifyNewSlot") }}

        </div>

        <div class="whatsAppSection" :style="{'gap': $vuetify.rtl ? '0' : '50px' } ">
          <div style="color: #424242" class="body-medium-16-medium" :class="$vuetify.rtl ? 'text-right' : 'text-left'">
            {{ $t("newPreSession.contactViaWhatsAppText") }}

          </div>
          <div>
            <a
                style="color: #39c990"
                href="https://wa.me/00989302672054"
                target="_blank"
                class="whatsAppButton title-small-16"
            >
              <img
                  src="@/assets/newPreSession/whatsapp.png"
                  alt=""
                  class="whatsAppIcon"
              />

              {{ $t("newPreSession.reserveOnWhatsApp") }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment-timezone";
import momentJalali from "moment-jalaali";
import {mapGetters} from "vuex";
import EventsMixins from "@/mixins/EventsMixins";

export default {
  mounted() {
    this.fetchingTimes();
  },
  mixins: [EventsMixins],

  computed: {
    ...mapGetters({profile: "getProfile"}),
  },

  data() {
    return {
      isExpanded: false,
      closestTime: null,
      closestTimeTemp: null,
      selectedTimeOption: "closest",
      selectedDayTime: null,
      selectedTab: 0,
      selectedDate: null,
      selectedTime: "",
      morningTimes: [],
      afternoonTimes: [],
      nightTimes: [],
      availableTimes: [],
      selectedTimeZone: null,
      finalDate: null,
      emptyState: false,
      loading: false,
      isFormLocked: false,
      timesRefreshed: false,
      animateBorder: false,
    };
  },
  methods: {
    scrollToBottom() {
      this.$nextTick(() => {
        window.scrollTo({
          top: document.body.scrollHeight,
          behavior: "smooth",
        })
      })
    },
    onTimeZoneChange(value) {
      if (value) {
        let selectedDate = this.selectedDate;
        this.fetchingTimes(value);
        this.emptyDayTimes();
        this.selectedDayTime = null;
        this.generateDateTimes(selectedDate);
      }
    },
    getPersianTimeLabel(timeString) {
      const [hour, minute] = timeString.split(":").map(Number);
      const totalMinutes = hour * 60 + minute;

      if (totalMinutes >= 0 && totalMinutes < 720) {
        return this.$t("newPreSession.morning");
      } else if (totalMinutes >= 720 && totalMinutes < 1080) {
        return this.$t("newPreSession.afternoon");
      } else {
        return this.$t("newPreSession.evening");
      }
    },
    generateDateTimes(date) {
      let periods = this.availableTimes.find(
          (item) => item.date === date
      ).periods;

      periods.map((item) => {
        if (this.getPersianTimeLabel(item.start) === this.$t('newPreSession.evening')) {
          this.nightTimes.push({
            id: item.id,
            time: item.start + this.$t('newPreSession.evening') + " ",
          });
        } else if (this.getPersianTimeLabel(item.start) === this.$t('newPreSession.afternoon')) {
          this.afternoonTimes.push({
            id: item.id,
            time: item.start + this.$t('newPreSession.afternoon') + " ",
          });
        } else {
          this.morningTimes.push({
            id: item.id,
            time: this.formatTimeWithAmPm(item.start),
          });
        }
      });
      if (this.morningTimes.length > 0)
        this.selectedTab = 0
      else if (this.afternoonTimes.length > 0)
        this.selectedTab = 1
      else
        this.selectedTab = 2
    },

    formatEachDate(date) {
      return moment(date, "YYYY/MM/DD").format("MMM DD");
    },
    formatTimeWithAmPm(timeString) {
      if (this.$vuetify.rtl) {
        return moment(timeString, "HH:mm")
            .format("hh:mm A")
            .replace("AM", "صبح")
            .replace("PM", "شب");
      } else {
        return moment(timeString, "HH:mm")
            .format("hh:mm A")

      }

    },
    getDayName(date) {
      if (this.$vuetify.rtl) {
        return momentJalali(date, "YYYY/MM/DD").locale("fa").format("dddd");
      } else {
        return moment(date, "YYYY/MM/DD").locale("en").format("dddd");

      }
    },

    updateUserTimeZoneIfEmpty(newTimezone) {
      if (!this.profile.tz || this.profile.tz === "UTC" || newTimezone) {
        this.selectedTimeZone = newTimezone ?? this.prepareDefaultTimezone();
        if (!this.selectedTimeZone) {
          this.$emitEvent("notify", {
            title: this.$t("newPreSession.selectTimezoneError"),
            color: "red",
          });
          this.isFormLocked = true;
          this.loading = true;
          return;
        }
        this.isFormLocked = false;
        this.$emitEvent("setLoading", true);
        this.loading = true;

        return this.requesting("auth", "editProfile", "", {
          timezone: this.selectedTimeZone,
        }).then(() => {
        });
      } else {
        this.selectedTimeZone = this.profile.tz;

        return Promise.resolve();
      }
    },

    fetchingTimes(newTimezone) {
      this.updateUserTimeZoneIfEmpty(newTimezone)
          .then(() => {
            this.loading = true;
            this.$emitEvent("setLoading", true);

            this.requesting("preSessionRequests", "getEmptyTimes").then(
                (response) => {
                  this.availableTimes = response.data.times;
                  if (response.data.times.length !== 0) {
                    let date = response.data.times[0].date;
                    let closestTime = response.data.times[0].periods[0].start;

                    this.closestTime =
                        this.getDayName(date) +
                        " " +
                        date +
                        " - " +
                        this.$t("newPreSession.hourText") +
                        response.data.times[0].periods[0].start +
                        " " +
                        this.getPersianTimeLabel(closestTime);

                    this.finalDate =
                        this.getDayName(date) +
                        " " +
                        date +
                        this.$t("newPreSession.hourText") +
                        " " +
                        closestTime +
                        " " +
                        this.getPersianTimeLabel(closestTime) +
                        "," +
                        " " +
                        `(${this.selectedTimeZone})`;
                    this.closestTimeTemp = this.finalDate;
                  } else {
                    this.emptyState = true;
                  }
                  this.$emitEvent("setLoading", false);
                  this.loading = false;
                }
            );
          })
          .finally(() => {
          });
    },
    emptyDayTimes() {
      this.morningTimes = [];
      this.afternoonTimes = [];
      this.nightTimes = [];
    },
    // prepareDefaultTimezone() {
    //   try {
    //     let options = { timeZoneName: "long" };
    //     return Intl.DateTimeFormat(undefined, options).resolvedOptions()
    //       .timeZone;
    //   } catch (er) {
    //     console.log(er);
    //   }
    // },

    normaliseTz(rawTz) {
      const canonical = this.timezoneAliases[rawTz] ?? rawTz;

      return this.timezones.some((t) => t.value === canonical)
          ? canonical
          : rawTz;
    },

    prepareDefaultTimezone() {
      try {
        const raw = Intl.DateTimeFormat().resolvedOptions().timeZone;

        return this.normaliseTz(raw);
      } catch {
        return null;
      }
    },
    onSelectingDate(date) {
      this.$nextTick(() => {
        window.scrollTo({
          top: document.body.scrollHeight * 2,
          behavior: "smooth",
        });
      });
      this.selectedDate = date;
      this.emptyDayTimes();
      this.selectedTab = 0;
      this.generateDateTimes(date);
    },

    toggleExpand() {
      this.isExpanded = !this.isExpanded;
    },

    async submitForm() {
      if (this.loading) return;

      if (!this.selectedDayTime && this.selectedTimeOption !== "closest") {
        this.$emitEvent("notify", {
          color: "red",
          title: this.$t("newPreSession.selectTimeErrorText")
        });
        return;
      }

      this.$emitEvent("setLoading", true);
      this.loading = true;

      try {
        const time_id =
            this.selectedTimeOption === "closest"
                ? this.availableTimes[0].periods[0].id
                : this.selectedDayTime;

        const res = await this.requesting(
            "preSessionRequests",
            "reserveTime",
            null,
            {time_id}
        );

        if (res.type === "success") {
          this.SendEventTrk({
            event_id: 'presession_' + Date.now(),
            name: 'pre_session_time',
            email: this.profile.email,
            first_name: this.profile.firstname,
            last_name: this.profile.lastname,
            payload: {}
          })
          this.$emit("change-step", 2);
          this.$emit("set-date", {date: this.finalDate, time_id});
        }
      } catch (e) {
        if (e?.response?.data?.data?.status === 1001) {
          this.loading = false;
          await this.fetchingTimes();
          this.emptyDayTimes();
          this.selectedTab = 0;
          this.timesRefreshed = true;
        } else {
          const msg =
              e?.response?.data?.message || this.$t("newPreSession.somethingWentWrong");
          this.$emitEvent("notify", {color: "red", title: msg});
        }
      } finally {
        this.$emitEvent("setLoading", false);
        this.loading = false;
      }
    },
  },
  watch: {
    timesRefreshed(val) {
      if (val) {
        this.animateBorder = true;
        setTimeout(() => {
          this.animateBorder = false;
        }, 3000);
      }
    },
    selectedTimeOption() {
      if (this.selectedTimeOption === "closest") {
        this.finalDate = this.closestTimeTemp;
      } else {
        this.scrollToBottom();
      }
      this.selectedDate = null;
    },
    selectedDayTime() {
      let period = this.availableTimes
          .find((item) => item.date === this.selectedDate)
          .periods.filter(
              (eachPeriod) => eachPeriod.id === this.selectedDayTime
          )[0];
      this.finalDate =
          this.getDayName(this.selectedDate) +
          " " +
          this.selectedDate +
          this.$t("newPreSession.hourText") +
          period.start +
          " " +
          this.getPersianTimeLabel(period.start) +
          " " +
          "," +
          `(${this.selectedTimeZone})`;
    },
  },
};
</script>

<style scoped>
@media (min-width: 300px) and (max-width: 1000px) {
  .eachBoxStyle {
    width: 700px !important;
  }

  .whatsAppButton {
    width: auto !important;
  }
}

.pageWrapper {
  width: 100%;
  height: auto;
  min-height: 100vh;
}

.preSessionHeader {
  width: 100%;
  box-shadow: 0 4px 12px -4px #0000001f;
  height: 128px;
  align-items: center;
  justify-content: center;
  display: flex;
}

.backIcon {
  width: 8px;
  height: 14px;
  margin-left: 4px;
}

.backImageContainer {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.backContainer {
  padding: 0 70px;
  display: flex;
  flex: 1;
  cursor: pointer;
}

.backContainerInner {
  display: flex;
  flex-direction: row;
}

.eachBoxStyle {
  background: #fff;
  border-radius: 12px;

  width: 900px;
  border: 1px solid #eaf0f6;
  transition: height 0.3s ease;
}

.firstSection {
  height: 140px;
}

.firstSection.expanded {
  height: auto;
}

.pageContent {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.secondSection {
  height: auto;
  margin-bottom: 100px;
}

.firstSectionHeader {
}

.firstSectionTop {
  border-bottom: 1px solid #eaf0f6;
  height: 70px;
  padding: 18px 24px;
}

.firstSectionBottom {
  display: flex;
  align-items: center;
  height: 70px;
  padding: 16px 24px;
}

.divider {
  width: 100%;
  height: 1px;
  background-color: #eaf0f6;
}

.sleeveImage {
  width: 24px;
  height: 28px;
  margin: 0 4px 0 4px;
}

.downArrowSelf {
  width: 24px;
  height: 24px;
  cursor: pointer;
  transition: transform 0.3s ease;
}

.downArrowSelf.rotated {
  transform: rotate(180deg);
}

.downArrowSection {
  display: flex;
  flex: 1;
  justify-content: flex-end;
}

.expandedContent {
  padding: 16px 24px;
  border-top: 1px solid #eaf0f6;
}

.infoRow {
  display: flex;
  margin-bottom: 12px;
}

.infoRow:last-child {
  margin-bottom: 0;
}

.infoLabel {
  margin-left: 4px;
}

.timezoneInput {
  margin: 24px;
  border-radius: 12px !important;
}

.custom-dropdown-arrow {
  transition: transform 0.3s ease;
  cursor: pointer;
}

.custom-dropdown-arrow.rotated {
  transform: rotate(180deg);
}

.timezoneInputWrapper :deep(.v-input__slot) fieldset {
  border-color: #eaf0f6 !important;
  border-width: 2px !important;
  border-radius: 16px !important;
}

.timezoneInputWrapper :deep(.v-input__slot):hover fieldset {
  border-color: #eaf0f6 !important;
  border-width: 2px !important;
}

.timezoneInputWrapper :deep(.v-input--is-focused .v-input__slot) fieldset {
  border-color: #3cbe8b !important;
  border-width: 2px !important;
}

.timezoneInputWrapper :deep(.v-text-field__details) {
  display: none !important;
}

.globeImg {
  width: 20px;
  height: 20px;
  margin-left: 10px;
}

.noteBookRow {
  display: flex;
  align-items: center;
  flex-direction: row;
  margin: 20px 0;
}

.noteBook {
  width: 28px;
  height: 28px;
  margin-right: 24px;
  margin-left: 4px;
}

.noteBookLtr {
  width: 28px;
  height: 28px;
  margin-left: 24px;
  margin-right: 8px;
}

.timingMargins {
  width: auto !important;
  padding: 12px 24px;
  margin: 0 24px;
}

.inspirationDiv {
  padding: 12px 28px;
  color: #035184;
  margin-top: 68px;
  width: 100%;
  background-color: #c5effe66;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
}

.smallSleeve {
  width: 28px;
  height: 28px;
  margin-left: 5px;
}

.submitSectionMargins {
  background-color: white;
  height: 80px;
  margin: 3px 24px;
}

.submitBtn {
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  width: 390px;
  height: 48px;
  background-color: #39c990;
  border-radius: 10px;
  cursor: pointer;
  transition: background-color 0.3s ease, box-shadow 0.3s ease;
}

.submitBtn:hover {
  background-color: #2ebd84; /* a slightly darker green */
  box-shadow: 0px 4px 12px rgba(57, 201, 144, 0.4); /* subtle greenish shadow */
}

::v-deep .my-radio-group .v-radio,
::v-deep .my-radio-group .v-input__slot,
::v-deep .my-radio-group .v-input__control,
::v-deep .my-radio-group .v-messages,
::v-deep .my-radio-group .v-messages__wrapper {
  padding: 0 !important;
  margin: 0 !important;
  min-height: 0 !important;
}

.timeSection {
  margin: 26px;
  display: flex;
}

.disabledDay {
  background-color: #f6f8fa !important;
  color: #bbb !important;
  pointer-events: none;
  opacity: 0.8;
}

.eachTimeBox {
  width: 114px;
  height: 110px;
  border: 1px solid #dbe4ed;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  cursor: pointer;
  transition: border 0.2s, background 0.2s, box-shadow 0.2s, color 0.2s;
  margin-left: 8px;
}

.eachTimeBox:hover {
  border: 1px solid #21c97a;
  background: linear-gradient(180deg, #fff 0%, #d7f4e9cc 80%);
  box-shadow: 0 2px 8px #eaf0f6;
  color: #39c990;
}

.selectedDay {
  border: 1px solid #21c97a !important;
  background: linear-gradient(180deg, #fff 0%, #d7f4e9cc 80%) !important;
  box-shadow: 0 2px 8px #eaf0f6;
  border-radius: 12px;
  transition: border 0.2s, background 0.2s;
  color: #39c990;
}

.disabledDay * {
  color: #bbb !important;
}

.eachDayTime {
  width: 115px;
  height: 48px;
  border: 1px solid #dbe4ed;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  margin-top: 10px;
  margin-left: 8px;
  cursor: pointer;
}

.time-row {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  margin: 24px 18px 0 18px;

  justify-content: flex-start;
  align-items: flex-start;
}

.time-box {
  text-align: center;
  border: 1px solid #dbe4ed;
  border-radius: 12px;
  background: #fff;
  transition: border 0.2s, background 0.2s, color 0.2s;
  cursor: pointer;
}

.time-box:hover {
  border: 1px solid #21c97a;
  background: linear-gradient(180deg, #fff 0%, #d7f4e9cc 80%);
  box-shadow: 0 2px 8px #eaf0f6;
  color: #39c990;
}

.expand-enter-active,
.expand-leave-active {
  transition: all 0.4s ease-in-out;
  overflow: hidden;
}

.expand-enter,
.expand-leave-to {
  max-height: 0;
  opacity: 0;
}

.expand-enter-to,
.expand-leave {
  max-height: 500px; /* or enough for your content */
  opacity: 1;
}

.emptyImage {
  width: 190px;
  height: 181px;
}

.emptyPanel {
  padding-top: 20px;
}

.expandHeight-enter-active,
.expandHeight-leave-active {
  transition: all 0.3s ease-in;
  overflow: hidden;
}

.expandHeight-enter,
.expandHeight-leave-to {
  max-height: 0;
  opacity: 0;
}

.expandHeight-enter-to,
.expandHeight-leave {
  max-height: 500px; /* or adjust to match your expected content height */
  opacity: 1;
}

.whatsAppSection {
  cursor: pointer;
  margin: 24px auto;
  width: 825px;
  height: 80px;
  padding: 16px 24px;
  display: flex;

  justify-content: space-between;
  text-align: right;
  border: 1px solid #eaf0f6;
  border-radius: 8px;
  align-self: center;
}

.whatsAppButton {
  border: 1px solid #39c990;
  border-radius: 8px;
  width: 346px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 24px;
  text-decoration: none !important;
}

.vTabStyle {
  border-bottom-width: 10px;
}

.whatsAppIcon {
  width: 24px;
  height: 24px;
  margin-left: 8px;
}

:deep(.v-tabs .v-tab) {
  border-bottom: 1px solid #eaf0f6;

  margin: 0 0px;
}

.submitBtn.is-disabled {
  background-color: #bdbdbd !important;
  cursor: not-allowed !important;
  box-shadow: none !important;
  opacity: 0.8;
  pointer-events: none;
  filter: grayscale(100%) blur(2px);

  transition: none;
}

.is-locked {
  opacity: 0.5;
  pointer-events: none;
  filter: grayscale(100%);
  transition: opacity 0.3s ease, filter 0.3s ease;
}

.recentlyUpdatedDiv {
  width: 199px;
  height: 36px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
}

.cautionImage {
  width: 16px;
  height: 16px;
  margin-left: 4px;
}

@keyframes pulse-border {
  0% {
    opacity: 0.3;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0.3;
  }
}

.animateCaution {
  animation: pulse-border 1.5s ease-in-out infinite;
}

.selectedBorder {
  border: 1px solid #39c990 !important;
}
</style>
